import {
    LIST_READING_SESSION_AUDIT,
    STORE_READING_SESSION_AUDIT,
    LIST_WEEKLY_REPORT_AUDIT,
    STORE_WEEKLY_REPORT_AUDIT,
} from '../../constants/audit';

export const listReadingSessionAudit = (data) => ({
    type: LIST_READING_SESSION_AUDIT,
    data,
});

export const storeReadingSessionAudit = (logs) => ({
    type: STORE_READING_SESSION_AUDIT,
    logs,
});

export const listWeeklyReportAudit = (data) => ({
    type: LIST_WEEKLY_REPORT_AUDIT,
    data,
});

export const storeWeeklyReportAudit = (logs) => ({
    type: STORE_WEEKLY_REPORT_AUDIT,
    logs,
});
